module.exports = __webpack_public_path__ + "img/cards_viva.a29aaa02.svg";